var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConInstaIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "con_insta_icn",
    transform: "translate(0 -1.332)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5296",
    "data-name": "Path 5296",
    transform: "translate(-3 -1.668)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,3H21a6,6,0,0,1,6,6V21a6,6,0,0,1-6,6H9a6,6,0,0,1-6-6V9A6,6,0,0,1,9,3Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 5.5 C 7.070089340209961 5.5 5.5 7.070089340209961 5.5 9 L 5.5 21 C 5.5 22.92991065979004 7.070089340209961 24.5 9 24.5 L 21 24.5 C 22.92991065979004 24.5 24.5 22.92991065979004 24.5 21 L 24.5 9 C 24.5 7.070089340209961 22.92991065979004 5.5 21 5.5 L 9 5.5 M 9 3 L 21 3 C 24.3137092590332 3 27 5.686290740966797 27 9 L 27 21 C 27 24.3137092590332 24.3137092590332 27 21 27 L 9 27 C 5.686290740966797 27 3 24.3137092590332 3 21 L 3 9 C 3 5.686290740966797 5.686290740966797 3 9 3 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_5297",
    "data-name": "Path 5297",
    transform: "translate(-5.065 -3.603)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.01,16.2A5,5,0,1,1,17.8,11.989,5,5,0,0,1,22.01,16.2Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.06288146972656 14.4348258972168 C 16.11392021179199 14.4348258972168 15.25901031494141 14.96213722229004 14.83176040649414 15.81099700927734 C 14.34588050842285 16.77631568908691 14.53287124633789 17.93831634521484 15.29705047607422 18.70249557495117 C 15.76929092407227 19.17473602294922 16.3975715637207 19.43481636047363 17.0661506652832 19.43481636047363 C 17.45890998840332 19.43481636047363 17.83654022216797 19.3449764251709 18.18857955932617 19.16778564453125 C 19.15391159057617 18.68190765380859 19.69598007202148 17.63720703125 19.53746032714844 16.56817626953125 C 19.37479019165039 15.47114562988281 18.52841186523438 14.62477684020996 17.43135070800781 14.46209716796875 C 17.30935096740723 14.44399642944336 17.18538093566895 14.4348258972168 17.06288146972656 14.4348258972168 M 17.0628833770752 11.9348258972168 C 17.30634117126465 11.9348258972168 17.55195236206055 11.95263862609863 17.79808044433594 11.9891357421875 C 19.97672080993652 12.31220626831055 21.6873607635498 14.02283668518066 22.01042175292969 16.20147705078125 C 22.32681083679199 18.33511734008789 21.23923110961914 20.43112564086914 19.31254959106445 21.40087699890137 C 17.3858699798584 22.37062644958496 15.05449104309082 21.99547576904297 13.52928161621094 20.47026634216309 C 12.00408172607422 18.94506645202637 11.62892150878906 16.61367607116699 12.59868049621582 14.6870059967041 C 13.45656394958496 12.98258209228516 15.19586944580078 11.9348258972168 17.0628833770752 11.9348258972168 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_931",
    "data-name": "Ellipse 931",
    transform: "translate(17 6.332)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1.25,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConInstaIcn);
export default __webpack_public_path__ + "static/media/con_insta_icn.e3422a291c8bd36fd02a2e76c9e16dc6.svg";
export { ForwardRef as ReactComponent };